export function unformatPhoneNumber(phoneNumberString = ''): string {
  if (phoneNumberString) {
    const phone = phoneNumberString.replace(/\D+/g, '')
    const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/)

    return match ? phone : phoneNumberString
  }
  return null
}
